import * as React from 'react';
import { GroupHeader } from '@ane/ui-components/lib/components/GroupedList';
import { SelectionMode } from '@ane/ui-components/lib/Utilities';
import { ConstrainMode } from '@ane/ui-components/lib/components/DetailsList';
import { DetailsListWithCommandBar } from '@ane/ui-components/lib/components/DetailsList/DetailsListWithCommandBar';
export function GetSubClisterListWhenAddChild(originalList, defaultChild) {
    originalList.forEach((item) => {
        item.collapsed = true;
    });
    defaultChild.collapsed = false;
    originalList = [...originalList, defaultChild];
    return originalList;
}
export class SubClusterList extends React.Component {
    constructor() {
        super(...arguments);
        this._getCommandItems = () => {
            const { isReadOnly } = this.props;
            const disabled = !!isReadOnly;
            return [
                {
                    key: 'addRow',
                    text: 'Add sub-cluster',
                    disabled: disabled,
                    iconProps: {
                        iconName: 'Add',
                    },
                    onClick: this.props.onAddSubCluster,
                },
                {
                    key: 'deleteRow',
                    text: 'Delete',
                    disabled: disabled,
                    iconProps: {
                        iconName: 'Delete',
                    },
                    onClick: this.props.onDeleteSubCluster,
                },
            ];
        };
        this._onRenderGroupHeader = (props) => (React.createElement(GroupHeader, Object.assign({}, props, { styles: { headerCount: { display: 'none' }, check: { opacity: 1 } }, onToggleCollapse: (group) => {
                if (props && props.onToggleCollapse) {
                    props === null || props === void 0 ? void 0 : props.onToggleCollapse(group);
                }
                if (group.data) {
                    group.data.collapsed = group.isCollapsed;
                }
            }, ariaColSpan: 1 })));
        this._getSubClusterGroups = () => {
            const { subClusterList } = this.props;
            return subClusterList.map((item, index) => {
                var _a;
                let groupName = 'Sub-cluster ' + (index + 1);
                return {
                    key: groupName,
                    name: groupName,
                    startIndex: index,
                    count: 1,
                    data: item,
                    isCollapsed: (_a = item.collapsed) !== null && _a !== void 0 ? _a : false,
                };
            });
        };
    }
    render() {
        return (React.createElement(DetailsListWithCommandBar, { commandBarProps: {
                items: this._getCommandItems(),
                ariaLabel: 'Create sub cluster command',
            }, detailsListProps: {
                compact: true,
                columns: [
                    {
                        key: 'subClusters',
                        name: 'Sub-clusters',
                        fieldName: 'subClusters',
                        minWidth: 100,
                        maxWidth: 200,
                        isResizable: true,
                    },
                ],
                defaultSortColumn: '',
                disableSort: true,
                ariaLabelForGrid: 'sub cluster list',
                constrainMode: ConstrainMode.unconstrained,
                selection: this.props.selection,
                selectionMode: SelectionMode.multiple,
                onRenderRow: (item) => this.props.onRenderSubCluster(item),
                groupProps: {
                    onRenderHeader: this._onRenderGroupHeader,
                },
                items: this.props.subClusterList,
                groups: this._getSubClusterGroups(),
                ariaLabelForSelectAllCheckbox: 'Toggle selection for all items',
                ariaLabelForSelectionColumn: 'Toggle selection',
                checkButtonAriaLabel: 'Row checkbox',
            } }));
    }
}

//# sourceMappingURL=SubClusterList.js.map
